import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage, useIntl } from 'dibs-react-intl';
import { LOCALE_US } from 'dibs-intl/exports/locales';

import { PdpSharedBuyerProtectionGuarantee } from './PdpSharedBuyerProtectionGuarantee';
import { PdpSharedBuyerProtection } from '../shared/PdpSharedBuyerProtection/PdpSharedBuyerProtection';
import { useEnhancedBuyerIncentivesClientVariant } from '../hooks/useEnhancedBuyerIncentivesClientVariant';

import { PdpSharedBuyerProtectionBox_user$key } from './__generated__/PdpSharedBuyerProtectionBox_user.graphql';

import styles from './PdpSharedBuyerProtection.scss';

const userFragment = graphql`
    fragment PdpSharedBuyerProtectionBox_user on User {
        ...PdpSharedBuyerProtectionGuarantee_user
        ...PdpSharedBuyerProtection_user
    }
`;

export const PdpSharedBuyerProtectionBox: FC<{
    user: PdpSharedBuyerProtectionBox_user$key | null;
}> = ({ user: userRef }) => {
    const user = useFragment(userFragment, userRef);

    const { locale } = useIntl();
    const isEnhancedBuyerIncentivesClientVariant = useEnhancedBuyerIncentivesClientVariant();

    return (
        <div className={styles.wrapper} data-tn="buyer-protection-wrrapper">
            {isEnhancedBuyerIncentivesClientVariant && (
                <PdpSharedBuyerProtection user={user} showLink className={styles.copy} />
            )}

            {isEnhancedBuyerIncentivesClientVariant === false && (
                <PdpSharedBuyerProtectionGuarantee user={user} />
            )}

            {locale !== LOCALE_US && (
                <div className={styles.copy}>
                    <div className={styles.message}>
                        <FormattedMessage
                            id="PdpSharedBuyerProtectionBox.translation.message"
                            defaultMessage="Parts of this page have been automatically translated. 1stDibs cannot guarantee the accuracy of translations. English is the default language of this website."
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
